import React, { useEffect, useState } from "react";
import IcecastMetadataPlayer from "icecast-metadata-player";
import ButtonPlayer from "../../button/ButtonPlayer";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux-hooks";
import {
  selectMainState,
  setButtonState,
  setCurrentUrl,
  setRadioOverTop,
  setPlayRadio,
  setPlayTrack,
  setTrackLink,
  setPreRollPlayed,
  setIdTrack,
  setAudioOverTop,
  setViewAudioPlayer,
} from "../../../../store/slices/main";
import { setPlaylistButtonState } from "../../../../store/slices/contests";
import { setSettingPlaylistPlaying } from "../../../../store/slices/playlists";

interface Props {
  type?: string;
  player: IcecastMetadataPlayer;
  main?: boolean;
}
const ControlButton: React.FC<Props> = ({ player, main }) => {
  const dispatch = useAppDispatch();
  const {
    radioPlayer: { buttonState, radio, preRollPlayed },
    audioPreRoll,
  } = useAppSelector(selectMainState);
  const [handleButton, setHandleButton] = useState<string>(buttonState);
  const [isPrerollPlaying, setIsPrerollPlaying] = useState(false);

  const handleClickWithPreroll = async () => {
    if (isPrerollPlaying) return;
    setIsPrerollPlaying(true);

    if (preRollPlayed === null && audioPreRoll.audioPreRollPath) {
      dispatch(setPreRollPlayed(true));
      dispatch(setTrackLink(audioPreRoll.audioPreRollPath));
      dispatch(setSettingPlaylistPlaying(false));
    } else {
      dispatch(setPreRollPlayed(false));
      dispatch(setPlayRadio(true));
      handleRadioClick();
    }
    setTimeout(() => setIsPrerollPlaying(false), 500);
  };

  const handleRadioClick = () => {
    dispatch(setPreRollPlayed(false));
    dispatch(setPlayTrack(false));
    dispatch(setPlayRadio(true));
    dispatch(
      setIdTrack({
        idTrack: "",
        cover: "",
        trackLink: "",
      })
    );

    if (buttonState === "play") {
      player.play();
      setHandleButton("pause");
      dispatch(setButtonState(handleButton));
      dispatch(setRadioOverTop(true));
      dispatch(setCurrentUrl(window.location.href));
    } else {
      player.stop();
      setHandleButton("play");
      dispatch(setButtonState(handleButton));
      dispatch(setCurrentUrl);
    }
  };

  useEffect(() => {
    if (preRollPlayed && radio) {
      dispatch(setTrackLink(""));
      handleRadioClick();
      dispatch(setPreRollPlayed(false));
    }
  }, [preRollPlayed, radio]);

  useEffect(() => {
    if (radio) dispatch(setPlaylistButtonState({ id: "radio" }));
  }, [radio, dispatch]);

  useEffect(() => {
    dispatch(setButtonState(handleButton));
  }, [handleButton, dispatch]);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      const isInteractiveTarget =
        target?.isContentEditable ||
        ["INPUT", "TEXTAREA", "SELECT", "BUTTON"].includes(target?.tagName ?? "");

      if (event.code === "Space" && !isInteractiveTarget) {
        event.preventDefault();
        handleClickWithPreroll();
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleClickWithPreroll]);

  return (
    <>
      <ButtonPlayer
        type={buttonState}
        main={main}
        onClick={handleClickWithPreroll}
        // onTouchEnd={(e) => {
        //   e.preventDefault();
        //   handleClickWithPreroll();
        // }}
      />
    </>
  );
};

export default ControlButton;
